var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wyse-range"},[_c('input',{attrs:{"type":"range","max":_vm.max},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }